module.exports = __webpack_public_path__ + "o.no2.309d82f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/o.no2.jpg
// module id = 0gM/
// module chunks = 0